import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { TransactionType } from 'dashboard/models/transaction-type';
import { TransactionTypeGridLayout } from 'dashboard/models/transaction-type-grid-layout';
import { TransactionVariableDefinition } from 'dashboard/models/transaction-variable-definition';

export interface State {
  transactionType: TransactionType | null;
  gridLayouts: TransactionTypeGridLayout[];
  transactionVariableDefinitions: TransactionVariableDefinition[];
}
export const initialState: State = {
  transactionType: null,
  gridLayouts: [],
  transactionVariableDefinitions: [],
};

const { reducer, actions } = createSlice({
  name: 'transaction-type',
  initialState,
  reducers: {
    setTransactionType: (state, action: PayloadAction<TransactionType>) => {
      state.transactionType = action.payload;
    },
    clearTransactionType: (state) => {
      state.transactionType = null;
    },
    updateDefaultStatus: (state, action: PayloadAction<TransactionType>) => {
      state.transactionType = action.payload;
    },
    addTransactionTypeGridLayout: (state, action: PayloadAction<TransactionTypeGridLayout>) => {
      state.gridLayouts.push(action.payload);
    },
    setTransactionTypeGridLayouts: (state, action: PayloadAction<TransactionTypeGridLayout[]>) => {
      state.gridLayouts = action.payload;
    },
    setTransactionTypeGridLayout: (state, action: PayloadAction<TransactionTypeGridLayout>) => {
      const index = state.gridLayouts.findIndex(
        (gridLayout) => gridLayout.id === action.payload.id,
      );

      // this should never happen because we are updating an existing grid layout
      if (index === -1) throw new Error('Transaction type grid layout not found');

      state.gridLayouts[index] = action.payload;
    },
    setTransactionVariableDefinitions: (
      state,
      action: PayloadAction<TransactionVariableDefinition[]>,
    ) => {
      state.transactionVariableDefinitions = action.payload;
    },
  },
});

export const {
  setTransactionType,
  clearTransactionType,
  updateDefaultStatus,
  addTransactionTypeGridLayout,
  setTransactionTypeGridLayouts,
  setTransactionTypeGridLayout,
  setTransactionVariableDefinitions,
} = actions;
export const transactionTypeReducer = reducer;
